export const getToken = () => {
    const token = localStorage.getItem("token");
    return token || "";
  };
  
  export const setToken = (token: string) => {
    localStorage.setItem("token", token);
  };

  export const clearToken = () => {
    localStorage.removeItem("token");
  };

export const getUser = () => {
    const user = localStorage.getItem("user");
    return user || "";
  };
  
  export const setUser = (user: string) => {
    localStorage.setItem("user", user);
  };

  export const clearUserPhone = () => {
    localStorage.removeItem("userPhone");
  };

  export const getUserPhone = () => {
    const userPhone = localStorage.getItem("userPhone");
    return userPhone || "";
  };
  
  export const setUserPhone = (userPhone: string) => {
    localStorage.setItem("userPhone", userPhone);
  };
